import React from 'react'
import { HTMLContainer, ShapeUtil, TLBaseShape, Rectangle2d } from '@bigbluebutton/tldraw'
import { ReactNode } from 'react'

type SVGShape = TLBaseShape<'svgshape', { w: number; h: number; svgContent: string }> & {
  x: number; 
  y: number;  
  rotation: number; 
  index: number;  
}

export class SVGShapeUtil extends ShapeUtil<SVGShape> {
  static override type = 'svgshape' as const

  getDefaultProps(): SVGShape['props'] {
    return {
      w: 150,      
      h: 150,      
      svgContent: '',  
    }
  }

  getGeometry(shape: SVGShape) {
    return new Rectangle2d({
      width: shape.props.w,
      height: shape.props.h,
      isFilled: true,
    })
  }

  component(shape: SVGShape): ReactNode {
    return (
      <HTMLContainer>
        <svg
          width={shape.props.w}
          height={shape.props.h}
          xmlns="http://www.w3.org/2000/svg"
          viewBox={`0 0 ${shape.props.w} ${shape.props.h}`}
        >
          {shape.props.svgContent ? (
            <g dangerouslySetInnerHTML={{ __html: shape.props.svgContent }} />
          ) : (
            <circle cx={shape.props.w / 2} cy={shape.props.h / 2} r={50} fill="blue" />
          )}
        </svg>
      </HTMLContainer>
    )
  }

  indicator(shape: SVGShape) {
    return <rect width={shape.props.w} height={shape.props.h} />
  }
}
